import {
  TextComponent,
  TextComponentProps,
} from '@manifest-cyber/design-system/lib/components/TextComponent';
import { Checkbox, CheckboxProps } from '@mantine/core';
import { clsx } from 'clsx';
import styles from './ManifestCheckbox.module.scss';

interface ManifestCheckboxProps
  extends Omit<CheckboxProps, 'sx' | 'style' | 'classNames'> {
  labelTextVariant?: TextComponentProps['variant'];
}

const ManifestCheckbox = ({
  label,
  indeterminate,
  checked,
  disabled,
  labelTextVariant,
  ...props
}: ManifestCheckboxProps) => {
  return (
    <Checkbox
      classNames={{
        input: clsx(styles.input, indeterminate && styles.indeterminateCheckbox),
        icon: disabled ? styles.disabledCheckboxIcon : styles.icon,
      }}
      label={<TextComponent variant={labelTextVariant}>{label}</TextComponent>}
      checked={!indeterminate && checked}
      indeterminate={indeterminate}
      disabled={disabled}
      {...props}
    />
  );
};

ManifestCheckbox.Group = Checkbox.Group;

export { ManifestCheckbox };
